import a from "./index888.js";
import e from "./index889.js";
function l(h, m, t, g, n) {
  var o = -1, f = h.length;
  for (t || (t = e), n || (n = []); ++o < f; ) {
    var i = h[o];
    t(i) ? a(n, i) : n[n.length] = i;
  }
  return n;
}
export {
  l as default
};
